import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import {
  getMeetingRoomList,
  listAllUnitForMeetingForRoomCheck,
} from "../../redux/actions/meetingRoomAction/meetingRoomAction";
import { useSelector, useDispatch } from "react-redux";
import CommonStepper from "../Common/CommonStepper";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  clearState,
  createMeetingDetails,
  getCreateMeetingStep,
  getTimelineList,
  setErrorMessage,
  updateIsCreateMeetingProcessed,
  updateMeetingDetails,
  updateStep,
} from "../../redux/actions/meetingActions/MeetingAction";
import * as constantMessages from "../../constants/constatntMessages";
import "../Login/style/Login.css";
import LoaderButton from "../Common/LoaderButton";
import AddAttendees from "./AddAttendees";
import AddAgendas from "./AddAgendas";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  logOut,
  setInValidUser,
} from "../../redux/actions/authActions/authAction";
import {
  checkCharacterLeft,
  cleanInput,
  parseDate,
} from "../../helpers/commonHelpers";
import { textBoxStrLength } from "../../config/config";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { handleApiError } from "../../helpers/errorResponseHelper";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const AddMeeting = () => {
  const [isAmPm, setIsAmPm] = useState(null);
  const regularExpressionForAgendaTitle =
    /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;
  useEffect(() => {
    const testTime = new Date().toLocaleTimeString();
    const is12Hour = testTime.includes("AM") || testTime.includes("PM");
    setIsAmPm(is12Hour);
  }, []);

  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const accessToken = localStorage.getItem("accessToken");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const meetingRoomData = useSelector((state) => state.meetingRoom);
  const meetingData = useSelector((state) => state.meeting);
  const organizationData = useSelector((state) => state.organization);
  const zoomCred =
    organizationData?.organizationData?.hostingDetails?.zoomCredentials;
  const gmeetCred =
    organizationData?.organizationData?.hostingDetails?.gMeetCredentials;
  const msTeamsCred =
    organizationData?.organizationData?.hostingDetails?.msTeamCredentials;
  const [unitId, setUnitId] = useState(null);
  const [selectedRoomOption, setSelectedRoomOption] = useState([
    { label: "Select Room", value: "" },
  ]);
  const [selectedUnitOption, setSelectedUnitOption] = useState([
    { label: "Select Unit", value: "" },
  ]);
  const employeeData = useSelector((state) => state.user);
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [roomErrors, setRoomErrors] = useState({});
  const [zoomError, setZoomError] = useState(null);
  const [isPreviousChildMeetingAvailable, setIsPreviousChildMeetingAvailable] =
    useState(false);

  const [formData, setFormData] = useState({
    title: "",
    mode: "physical",
    location: "manual",
    date: dayjs().format("DD-MM-YYYY"),
    link: "",
    fromTime:
      dayjs().minute() < 30
        ? dayjs().minute(30).second(0).format("HH:mm")
        : dayjs().add(1, "hour").minute(0).second(0).format("HH:mm"),
    toTime:
      dayjs().minute() < 30
        ? dayjs().minute(30).second(0).add(60, "minute").format("HH:mm")
        : dayjs()
            .add(1, "hour")
            .minute(0)
            .second(0)
            .add(60, "minute")
            .format("HH:mm"), // e.g., 30-minute duration
    roomId: "",
    unitId: "",
    locationData: "",
    linkType: null,
  });

  const location = useLocation();
  const stateData = location.state;

  //////////////////////

  useEffect(() => {
    if (stateData?.meetingId) {
      dispatch(getTimelineList(stateData?.meetingId, accessToken));
    }

    return () => {};
  }, [stateData?.meetingId]);

  const followonDetails =
    meetingData?.timeLineDatas?.followonMeetingDetails || [];

  let previousMeetingData = undefined;

  if (followonDetails.length > 1) {
    previousMeetingData = [...followonDetails]
      .reverse()
      .find((item) => item.isActive === true);
  }

  const followOnMeetingCount = meetingData?.timeLineDatas
    ?.followonMeetingDetails
    ? meetingData?.timeLineDatas?.followonMeetingDetails?.length - 1
    : 0;

  const parentMeetingData = meetingData?.timeLineDatas?.parentMeetingDetails;
  const followOnMeetings = meetingData?.timeLineDatas?.followonMeetingDetails;

  ////////////////

  useEffect(() => {
    if (!meetingData?.singleMeetingDetails?.unitDetail) {
      setUnitId(null);
    }
  }, []);
  useEffect(() => {
    if (formData.toTime) {
      toDateFieldValidationCheck(formData.toTime);
    }
  }, [formData.toTime]); // Runs whenever toTime updates
  useEffect(() => {
    if (formData.fromTime) {
      if (previousMeetingData) {
        fromDateFieldValidationCheckForPrevious();
      } else {
        fromDateFieldValidationCheck();
      }
    }
  }, [formData.fromTime]); // Runs whenever toTime updates

  useEffect(() => {
    if (meetingData?.isClearState) {
      setFormData({
        title: "",
        mode: "physical",
        location: "manual",
        date: dayjs().format("DD-MM-YYYY"),
        link: "",
        fromTime:
          dayjs().minute() < 30
            ? dayjs().minute(30).second(0).format("HH:mm")
            : dayjs().add(1, "hour").minute(0).second(0).format("HH:mm"),
        toTime:
          dayjs().minute() < 30
            ? dayjs().minute(30).second(0).add(60, "minute").format("HH:mm")
            : dayjs()
                .add(1, "hour")
                .minute(0)
                .second(0)
                .add(60, "minute")
                .format("HH:mm"), // e.g., 30-minute duration
        roomId: "",
        unitId: "",
        locationData: "",
        linkType: null,
      });
    }
    return () => {
      clearState(false);
    };
  }, [meetingData?.isClearState]);

  useEffect(() => {
    setSelectedRoomOption([{ label: "Select Rooms", value: "" }]);
    document.title = "Create Meeting: MinutesVault";
    if (
      !meetingData.isNewMeetingPage &&
      !meetingData.isUpdateStep &&
      meetingData?.singleMeetingDetails?.step === 0
    ) {
      dispatch(getCreateMeetingStep(userData.organizationId, accessToken));
    }
    if (
      meetingData?.isSuccess ||
      meetingData?.isNewMeetingPage ||
      stateData?.isNewMeeting
    ) {
      setFormData({
        ...formData,
        title: "",
        mode: "physical",
        location: "manual",
        date: dayjs().format("DD-MM-YYYY"),
        link: "",
        fromTime:
          dayjs().minute() < 30
            ? dayjs().minute(30).second(0).format("HH:mm")
            : dayjs().add(1, "hour").minute(0).second(0).format("HH:mm"),
        toTime:
          dayjs().minute() < 30
            ? dayjs().minute(30).second(0).add(60, "minute").format("HH:mm")
            : dayjs()
                .add(1, "hour")
                .minute(0)
                .second(0)
                .add(60, "minute")
                .format("HH:mm"), // e.g., 30-minute duration
        roomId: "",
        unitId: "",
        locationData: "",
        linkType: null,
      });
      setSelectedRoomOption([{ label: "*Select Rooms", value: "" }]);

      if (employeeData?.userData?.unitDetails) {
        setUnitId(employeeData?.userData?.unitDetails?._id);

        const payload = {
          organizationId: userData.organizationId,
          unitId: meetingData.singleMeetingDetails?.unitDetail?._id
            ? meetingData.singleMeetingDetails?.unitDetail?._id
            : employeeData?.userData?.unitDetails?._id,
        };

        dispatch(getMeetingRoomList(payload, accessToken));
        setSelectedUnitOption([
          {
            label: employeeData?.userData?.unitDetails?.name,
            value: employeeData?.userData?.unitDetails?._id,
          },
        ]);
        setFormData({
          ...formData,
          unitId: employeeData?.userData?.unitDetails?._id,
        });
      } else {
        setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
      }
    }

    if (meetingData?.singleMeetingDetails?.step === 0) {
      setStep(meetingData.step + 1);
    }
    if (meetingData.singleMeetingDetails && meetingData.isUpdateStep) {
      if (meetingData?.singleMeetingDetails?.date) {
        var date = new Date(meetingData?.singleMeetingDetails?.date);
        var dateString = new Date(
          date?.getTime() - date?.getTimezoneOffset() * 60000
        )
          .toISOString()
          .split("T")[0];
      }
      setFormData({
        ...formData,
        title: meetingData.singleMeetingDetails.title,
        mode: meetingData.singleMeetingDetails.mode.toLowerCase(),
        location: meetingData.singleMeetingDetails.locationDetails.isMeetingRoom
          ? "meetingroom"
          : "manual",
        date: dateString ? dayjs(dateString).format("DD-MM-YYYY") : null,
        link: meetingData.singleMeetingDetails.link
          ? meetingData.singleMeetingDetails.link
          : "",
        fromTime: meetingData?.singleMeetingDetails?.actualFromTime,
        toTime: meetingData?.singleMeetingDetails?.actualToTime,
        roomId: meetingData?.singleMeetingDetails?.locationDetails?.roomId,
        locationData: meetingData?.singleMeetingDetails?.locationDetails
          ?.location
          ? meetingData?.singleMeetingDetails?.locationDetails?.location
          : "",
        linkType: meetingData?.singleMeetingDetails?.linkType
          ? meetingData?.singleMeetingDetails?.linkType
          : meetingData?.singleMeetingDetails?.hostDetails?.hostType
            ? meetingData?.singleMeetingDetails?.hostDetails?.hostType
            : null,
      });
      if (
        meetingData?.singleMeetingDetails?.locationDetails?.isMeetingRoom &&
        !meetingData?.singleMeetingDetails?.locationDetails?.location
      ) {
        setSelectedRoomOption({
          value: meetingData?.singleMeetingDetails?.roomDetail[0]._id,
          label: meetingData?.singleMeetingDetails?.roomDetail[0].title,
          name: "roomId",
        });
        if (meetingData?.singleMeetingDetails?.unitDetail) {
          setSelectedUnitOption({
            value: meetingData?.singleMeetingDetails?.unitDetail?._id,
            label: meetingData?.singleMeetingDetails?.unitDetail?.name,
            name: "unitId",
          });

          setUnitId(meetingData?.singleMeetingDetails?.unitDetail?._id);
        } else {
          setUnitId(null);
        }
      }
      if (meetingData?.singleMeetingDetails?.locationDetails?.isMeetingRoom) {
        const payload = {
          organizationId: userData?.organizationId,
        };
        dispatch(listAllUnitForMeetingForRoomCheck(payload, accessToken));
      }
    }
  }, [meetingData.step, meetingData.isNewMeetingPage]);

  ////// auto generated follow-on meeting title ////////

  useEffect(() => {
    if (parentMeetingData && !formData.title && !meetingData?.isClearState) {
      const { title, date } = parentMeetingData;
      const parentId = parentMeetingData._id;
      let serialNumber = 0;
      if (followOnMeetingCount) {
        serialNumber = followOnMeetingCount + 1;
      } else {
        const existingFollowOns = (followOnMeetings || []).filter(
          (meeting) => meeting._id !== parentId
        );
        serialNumber = existingFollowOns.length + 1;
      }

      const generatedTitle = `Follow-On: ${serialNumber} - ${title}`;

      const actualToTime = parentMeetingData?.actualToTime;

      let newFromTime = formData.fromTime;
      let newToTime = formData.toTime;
      const currentDate = dayjs(); // Current date using dayjs

      const formDate = dayjs(date, "DD MMM YYYY"); // Correct format for "08 Jun 2025"

      if (actualToTime && currentDate.isSame(formDate, "day")) {
        const [hours, mins] = actualToTime.split(":").map(Number);
        const correctedTime = dayjs().hour(hours).minute(mins);

        let roundedFromTime = null;
        if (mins < 30) {
          roundedFromTime = correctedTime.minute(0).add(30, "minute");
        } else {
          roundedFromTime = correctedTime
            .hour(hours)
            .add(1, "hour")
            .minute(0)
            .add(0, "minute");
        }

        newFromTime = roundedFromTime.format("HH:mm");
        newToTime = roundedFromTime.add(30, "minute").format("HH:mm");
      }

      setFormData((prev) => ({
        ...prev,
        title: generatedTitle,
        fromTime: newFromTime,
        toTime: newToTime,
      }));
    }
  }, [parentMeetingData, followOnMeetings]);

  useEffect(() => {
    if (previousMeetingData && !formData.title && !meetingData?.isClearState) {
      setIsPreviousChildMeetingAvailable(true);

      const { title, date } = previousMeetingData;

      const actualToTime = previousMeetingData?.actualToTime;

      let newFromTime = formData.fromTime;
      let newToTime = formData.toTime;
      const currentDate = dayjs(); // Current date using dayjs

      const formDate = dayjs(date, "DD MMM YYYY"); // Correct format for "08 Jun 2025"

      if (actualToTime && currentDate.isSame(formDate, "day")) {
        const [hours, mins] = actualToTime.split(":").map(Number);
        const correctedTime = dayjs().hour(hours).minute(mins);

        let roundedFromTime = null;
        if (mins < 30) {
          roundedFromTime = correctedTime.minute(0).add(30, "minute");
        } else {
          roundedFromTime = correctedTime
            .hour(hours)
            .add(1, "hour")
            .minute(0)
            .add(0, "minute");
        }

        newFromTime = roundedFromTime.format("HH:mm");
        newToTime = roundedFromTime.add(30, "minute").format("HH:mm");
        setFormData((prev) => ({
          ...prev,

          fromTime: newFromTime,
          toTime: newToTime,
        }));
      }

      if (actualToTime && currentDate.isBefore(formDate, "day")) {
        const [hours, mins] = actualToTime.split(":").map(Number);
        const correctedTime = dayjs().hour(hours).minute(mins);

        let roundedFromTime = null;
        if (mins < 30) {
          roundedFromTime = correctedTime.minute(0).add(30, "minute");
        } else {
          roundedFromTime = correctedTime
            .hour(hours)
            .add(1, "hour")
            .minute(0)
            .add(0, "minute");
        }

        newFromTime = roundedFromTime.format("HH:mm");
        newToTime = roundedFromTime.add(30, "minute").format("HH:mm");
        setFormData((prev) => ({
          ...prev,

          date: dayjs(date).format("DD-MM-YYYY"),
          fromTime: newFromTime,
          toTime: newToTime,
        }));
      }
    }
  }, [previousMeetingData, followOnMeetings]);

  //////////////////////////////////////////////////////////

  if (meetingRoomData?.meetingRoomList?.length !== 0) {
    var roomOptions = meetingRoomData?.meetingRoomList?.map((room) => {
      const returnData = {
        value: room._id,
        label: room.title,
        name: "roomId",
      };

      return returnData;
    });
  }

  if (meetingRoomData?.unitList?.length !== 0) {
    var unitOptions = meetingRoomData?.unitList?.map((unit) => {
      const returnData = {
        value: unit._id,
        label: unit.name,
        name: "unitId",
      };

      return returnData;
    });
  }

  const handledateChange = async (name, value) => {
    const errors = {};

    dispatch(setErrorMessage(null));
    setRoomErrors({});
    dispatch(updateIsCreateMeetingProcessed(false));
    setErrors({});
    if (value !== null && value !== "Invalid Date") {
      let formattedValue = value; // Default to the provided value
      if (dayjs.isDayjs(value)) {
        if (name === "date") {
          formattedValue = dayjs(value)?.format("DD-MM-YYYY");

          const mDate = dayjs(value)?.format("YYYY-MM-DD");

          if (parentMeetingData?.actualDate) {
            if (
              mDate <
              dayjs.utc(parentMeetingData?.actualDate).format("YYYY-MM-DD")
            ) {
              errors.date = constantMessages.invalidFollowOnMeetingDate;
            }
          }
        } else if (name.includes("Time")) {
          formattedValue = dayjs(value)?.format("HH:mm");
          setFormData({
            ...formData,
            [name]: formattedValue,
          });
        }
      }

      setFormData((prev) => {
        const updatedFormData = { ...prev, [name]: formattedValue };

        // Ensure zoomError state is updated correctly
        setZoomError((prevErrors) => ({
          ...prevErrors,
          [name]: formattedValue ? "" : prevErrors[name],
        }));

        // If `linkType` is changed, update it
        if (name === "linkType") {
          updatedFormData["linkType"] = formattedValue; // Ensure correct string storage
        }

        // Check Zoom meeting only when all required fields are filled
        if (
          updatedFormData?.linkType === "ZOOM" &&
          updatedFormData?.date &&
          updatedFormData?.fromTime &&
          updatedFormData?.toTime
        ) {
          checkZoomMeeting(updatedFormData);
        } else {
          setZoomError(null);
        }

        return updatedFormData;
      });
      setErrors(errors);
    }
  };

  const handledateChangeForPreviousMeeting = async (name, value) => {
    const errors = {};

    dispatch(setErrorMessage(null));
    setRoomErrors({});
    setErrors({});
    dispatch(updateIsCreateMeetingProcessed(false));
    if (value !== null && value !== "Invalid Date") {
      let formattedValue = value; // Default to the provided value

      if (dayjs.isDayjs(value)) {
        if (name === "date") {
          formattedValue = dayjs(value)?.format("DD-MM-YYYY");

          const mDate = dayjs(value)?.format("YYYY-MM-DD");

          if (previousMeetingData?.actualDate) {
            if (
              mDate <
              dayjs.utc(previousMeetingData?.actualDate).format("YYYY-MM-DD")
            ) {
              errors.date =
                isPreviousChildMeetingAvailable === false
                  ? constantMessages.invalidFollowOnMeetingDate
                  : constantMessages.invalidFollowOnMeetingDateForPreviousMeeting;
            }
          }
        } else if (name.includes("Time")) {
          formattedValue = value.format("HH:mm"); //  Store Time in 24-hour format
          setFormData({
            ...formData,
            [name]: formattedValue,
          });
        }
      }

      setFormData((prev) => {
        const updatedFormData = { ...prev, [name]: formattedValue };

        // Ensure zoomError state is updated correctly
        setZoomError((prevErrors) => ({
          ...prevErrors,
          [name]: formattedValue ? "" : prevErrors[name],
        }));

        // If `linkType` is changed, update it
        if (name === "linkType") {
          updatedFormData["linkType"] = formattedValue; // Ensure correct string storage
        }

        // Check Zoom meeting only when all required fields are filled
        if (
          updatedFormData?.linkType === "ZOOM" &&
          updatedFormData?.date &&
          updatedFormData?.fromTime &&
          updatedFormData?.toTime
        ) {
          checkZoomMeeting(updatedFormData);
        } else {
          setZoomError(null);
        }

        return updatedFormData;
      });
      setErrors(errors);
    }
  };

  // API call function
  const checkZoomMeeting = async (formData) => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/meeting/check-zoom-meeting`;
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };

      const payload = {
        date: await parseDate(formData.date),
        fromTime: formData.fromTime,
        toTime: formData.toTime,
        organizationId: userData.organizationId,
      };

      const response = await axios.post(webApiUrl, payload, headerObject);

      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        dispatch(setInValidUser(false));
      }
      if (!response.data.success || response.data.data.existingZoomMeeting) {
        const errorMessage =
          response.data.message || "A Zoom meeting is already scheduled.";

        setZoomError(errorMessage);
        setErrors((prevErrors) => ({
          ...prevErrors,
          zoomError: errorMessage,
        }));
      } else {
        setZoomError(null);
        setErrors((prevErrors) => ({
          ...prevErrors,
          zoomError: "",
        }));
      }
    } catch (error) {
      if (handleApiError(error)) return;
      console.error("API Error:", error);
      const errorMessage =
        error.response?.data?.message || "Something went wrong.";

      setZoomError(errorMessage);
      setErrors((prevErrors) => ({
        ...prevErrors,
        zoomError: errorMessage,
      }));
    }
  };

  //pratishruti add code here

  const handleRoomChange = async (e) => {
    dispatch(updateIsCreateMeetingProcessed(false));
    setErrors({});
    setRoomErrors({});
    dispatch(setErrorMessage(null));
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedRoomOption(e);
    if (!formData.date || !formData.fromTime || !formData.toTime) {
      return;
    }
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/meeting/check-meetingroom-availability`;
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };

      const payload = {
        roomId: value,
        date: await parseDate(formData.date),
        fromTime: formData.fromTime,
        toTime: formData.toTime,
        organizationId: userData.organizationId,
      };
      const response = await axios.post(webApiUrl, payload, headerObject);
      const resData = response.data;
      if (resData.success === false) {
        setRoomErrors((prevErrors) => ({
          ...prevErrors,
          room: resData.message,
        }));
      } else {
        setRoomErrors({});
      }
    } catch (error) {
      setErrors(error.response?.data?.message);
      if (handleApiError(error)) return;
    }
  };

  const handleRoomChangeForDate = async (e) => {
    dispatch(updateIsCreateMeetingProcessed(false));
    setErrors({});
    const { name, value } = e.target;

    if (
      !formData.date ||
      !formData.fromTime ||
      !formData.toTime ||
      !formData.roomId
    ) {
      return;
    }
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/meeting/check-meetingroom-availability`;
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };
      const payload = {
        roomId: formData.roomId,
        date: name === "date" ? value : formData.date,
        fromTime: name === "fromTime" ? value : formData.fromTime,
        toTime: name === "toTime" ? value : formData.toTime,
        organizationId: userData.organizationId,
      };
      const response = await axios.post(webApiUrl, payload, headerObject);
      const resData = response.data;
      if (resData.success === false) {
        setRoomErrors((prevErrors) => ({
          ...prevErrors,
          room: resData.message,
        }));
      } else {
        setRoomErrors({});
      }
    } catch (error) {
      if (handleApiError(error)) return;
      setErrors(error.response?.data?.message);
    }
  };

  const handleUnitChange = (e) => {
    setRoomErrors({});

    const { name, value } = e || {};
    if (name && value) {
      dispatch(updateIsCreateMeetingProcessed(false));
      setErrors({});

      setUnitId(value);
      setFormData((prev) => ({ ...prev, [name]: value, roomId: "" }));
      setSelectedUnitOption(e);
      dispatch(
        getMeetingRoomList(
          {
            organizationId: userData.organizationId,
            unitId: value,
          },
          accessToken
        )
      );
      setSelectedRoomOption([{ label: "Select Rooms", value: "" }]);
    }
  };

  const submitMeetingDetails = async (e) => {
    e.preventDefault();

    const newErrors = previousMeetingData
      ? validateFormForPreviousMeeting(formData)
      : validateForm(formData);

    if (errors.room) newErrors.room = errors.room;
    if (errors.zoomError) newErrors.zoomError = errors.zoomError;

    setErrors(newErrors);

    if (formData.linkType === "ZOOM" && zoomError) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        zoomError: zoomError,
      }));
      return;
    }

    if (
      Object.keys(newErrors).length !== 0 ||
      meetingData?.errorMessage !== null
    ) {
      return;
    }

    let locationDetails = {};
    if (formData.location === "meetingroom") {
      locationDetails["isMeetingRoom"] = true;
      locationDetails["roomId"] = formData.roomId;
    } else {
      locationDetails["isMeetingRoom"] = false;
      locationDetails["location"] = formData.locationData;
    }

    if (meetingData.singleMeetingDetails) {
      const meetingId = meetingData?.singleMeetingDetails?._id;
      const payload = {
        date: await parseDate(formData.date),
        locationDetails,
        organizationId: userData.organizationId,
        mode: formData.mode.toUpperCase(),
        fromTime: formData.fromTime,
        toTime: formData.toTime,
        title: cleanInput(formData.title),
        link: formData.link,
        step: 1,
        isUpdate: stateData.isMeetingDataUpdate ? true : false,
        sendNotification: false,
        linkType: formData.linkType ? formData.linkType : undefined,
      };
      const fromUpdate = meetingData?.singleMeetingDetails?.step === 3;
      dispatch(
        updateMeetingDetails(
          meetingId,
          payload,
          accessToken,
          "updateMeeting",
          false,
          false,
          fromUpdate
        )
      );
    } else {
      const payload = {
        date: await parseDate(formData?.date),
        locationDetails,
        organizationId: userData.organizationId,
        mode: formData.mode.toUpperCase(),
        fromTime: formData.fromTime,
        toTime: formData.toTime,
        title: cleanInput(formData.title),
        link: formData.link,
        linkType: formData.linkType ? formData.linkType : undefined,
        parentMeetingId: parentMeetingData?._id
          ? parentMeetingData._id
          : undefined,
      };
      dispatch(createMeetingDetails(payload, accessToken));
    }
  };

  const handleChange = (e) => {
    dispatch(setErrorMessage(null));
    dispatch(updateIsCreateMeetingProcessed(false));
    setErrors({});

    const { name, value } = e.target;

    if (name === "date" || name === "fromTime" || name === "toTime") {
      handleRoomChangeForDate(e);
    }

    if (name === "locationData") {
      if (value.length <= textBoxStrLength) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (value === "manual") {
      dispatch(setErrorMessage(null));
      setRoomErrors({});
    }

    if (value === "meetingroom") {
      const payload = {
        organizationId: userData.organizationId,
      };
      dispatch(listAllUnitForMeetingForRoomCheck(payload, accessToken));

      if (employeeData?.userData?.unitDetails) {
        setUnitId(employeeData?.userData?.unitDetails?._id);

        const payload = {
          organizationId: userData.organizationId,
          unitId: employeeData?.userData?.unitDetails?._id,
        };
        setSelectedUnitOption(e);
        dispatch(getMeetingRoomList(payload, accessToken));
        setSelectedUnitOption([
          {
            label: employeeData?.userData?.unitDetails?.name,
            value: employeeData?.userData?.unitDetails?._id,
          },
        ]);
      } else {
        setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
      }
    }

    if (!meetingData?.singleMeetingDetails?.unitDetail && value === "manual") {
      setUnitId(null);
      setSelectedRoomOption([{ label: "*Select Room", value: "" }]);
      setSelectedUnitOption([{ label: "*Select Unit", value: "" }]);
    }
    if (name === "mode" && value === "physical") {
      setFormData({
        ...formData,
        linkType: "MANUAL",
        link: "",
        mode: value,
      });
    }

    if (name === "mode" && value === "virtual") {
      setFormData({
        ...formData,
        linkType: null,
        link: "",
        mode: value,
      });
    }

    if (name === "mode" && value === "virtual") {
      setFormData({
        ...formData,
        linkType: "MANUAL",
        link: meetingData.singleMeetingDetails?.link
          ? meetingData.singleMeetingDetails?.link
          : "",
        mode: value,
      });
    }
    if (name === "title") {
      titleFieldValidationCheck();
    }
  };

  const validateForm = (data) => {
    const errors = {};
    if (!data.title.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (!regularExpressionForAgendaTitle.test(cleanInput(data.title))) {
      errors.title = constantMessages.titleRegexError;
    } else if (data.title.trim().length < 5 || data.title.trim().length > 100) {
      errors.title = constantMessages.stringLengthError;
    }

    if (!data.date.trim()) {
      errors.date = constantMessages.dateRequired;
    } else if (parentMeetingData?.actualDate) {
      const mDate = dayjs(formData.date, "DD-MM-YYYY");

      if (
        mDate.format("YYYY-MM-DD") <
        dayjs.utc(parentMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        errors.date = constantMessages.invalidFollowOnMeetingDate;
      }
    }
    setErrors(errors);
    if (!data.fromTime.trim()) {
      errors.fromTime = constantMessages.timeRequired;
    } else if (parentMeetingData?.actualToTime) {
      const parentMeetingToTime = parentMeetingData?.actualToTime;

      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const parentMeetingToTimeArray = parentMeetingToTime.split(":");
      const parentMeetingToHour = parentMeetingToTimeArray[0];
      const parentMeetingToMinute = parentMeetingToTimeArray[1];

      const mDate = dayjs(formData.date, "DD-MM-YYYY");

      if (
        mDate.format("YYYY-MM-DD") ===
        dayjs.utc(parentMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        if (fromTimeHour < parentMeetingToHour) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        } else if (
          fromTimeHour === parentMeetingToHour &&
          fromTimeMinute <= parentMeetingToMinute
        ) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        }
      }
    } else if (formData.toTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.fromTime = constantMessages.invalidFromHour;
      } else if (fromTimeHour === toTimeHour && fromTimeMinute > toTimeMinute) {
        errors.fromTime = constantMessages.invalidFromMinute;
      }
    }
    if (!data.toTime.trim()) {
      errors.toTime = constantMessages.timeRequired;
    } else if (formData.fromTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.toTime = constantMessages.invalidToHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.toTime = constantMessages.invalidToMinute;
      }
    }

    if (data.location === "meetingroom") {
      if (!unitId?.trim()) {
        errors.unitId = constantMessages.unitRequired;
      }
      if (!data?.roomId?.trim()) {
        errors.roomId = constantMessages.roomRequired;
      }
    } else {
      if (!data?.locationData?.trim()) {
        errors.locationData = constantMessages.locationRequired;
      } else if (!regularExpressionForAgendaTitle.test(data.locationData)) {
        errors.locationData = constantMessages.invalidInput;
      } else if (
        data.locationData.trim().length < 3 ||
        data.title.trim().length > 500
      ) {
        errors.locationData = constantMessages.largeStringLengthError;
      }
    }

    if (
      formData?.mode?.trim() === "virtual" &&
      formData?.linkType === "MANUAL"
    ) {
      if (!formData?.link?.trim()) {
        errors.link = constantMessages.linkRequired;
      }
    }

    // If Zoom is selected as link type, check required fields
    if (data.linkType === "ZOOM") {
      if (!data.date.trim()) {
        errors.linkType = "Please select a valid date for Zoom meeting.";
      }
      if (!data.fromTime.trim()) {
        errors.linkType = "Please select a valid from-time for Zoom meeting.";
      }
      if (!data.toTime.trim()) {
        errors.linkType = "Please select a valid to-time for Zoom meeting.";
      }
    }

    if (formData?.mode?.trim() === "virtual") {
      if (!formData?.linkType) {
        errors.linkType = "Please add link type";
      }
    }

    const regexp =
      /^(?:(?:https?:)?\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (formData.link.trim()) {
      if (!regexp.test(formData.link.trim())) {
        errors.link = constantMessages.invalidLink;
      }
    }
    return errors;
  };

  const validateFormForPreviousMeeting = (data) => {
    const errors = {};
    if (!data.title.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (!regularExpressionForAgendaTitle.test(cleanInput(data.title))) {
      errors.title = constantMessages.titleRegexError;
    } else if (data.title.trim().length < 5 || data.title.trim().length > 100) {
      errors.title = constantMessages.stringLengthError;
    }

    if (!data?.date?.trim()) {
      errors.date = constantMessages.dateRequired;
    } else if (parentMeetingData?.actualDate) {
      const mDate = dayjs(formData.date, "DD-MM-YYYY");

      if (
        mDate.format("YYYY-MM-DD") <
        dayjs.utc(previousMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        errors.date =
          constantMessages.invalidFollowOnMeetingDateForPreviousMeeting;
      }
    }
    setErrors(errors);
    if (!data.fromTime.trim()) {
      errors.fromTime = constantMessages.timeRequired;
    } else if (previousMeetingData?.actualToTime) {
      const parentMeetingToTime = previousMeetingData?.actualToTime;
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const parentMeetingToTimeArray = parentMeetingToTime.split(":");
      const parentMeetingToHour = parentMeetingToTimeArray[0];
      const parentMeetingToMinute = parentMeetingToTimeArray[1];
      const mDate = dayjs(formData.date, "DD-MM-YYYY");

      if (
        mDate.format("YYYY-MM-DD") ===
        dayjs.utc(previousMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        if (fromTimeHour < parentMeetingToHour) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        } else if (
          fromTimeHour === parentMeetingToHour &&
          fromTimeMinute <= parentMeetingToMinute
        ) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        }
      }
    } else if (formData.toTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.fromTime = constantMessages.invalidFromHour;
      } else if (fromTimeHour === toTimeHour && fromTimeMinute > toTimeMinute) {
        errors.fromTime = constantMessages.invalidFromMinute;
      }
    }
    if (!data.toTime.trim()) {
      errors.toTime = constantMessages.timeRequired;
    } else if (formData.fromTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.toTime = constantMessages.invalidToHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.toTime = constantMessages.invalidToMinute;
      }
    }

    if (data.location === "meetingroom") {
      if (!unitId?.trim()) {
        errors.unitId = constantMessages.unitRequired;
      }
      if (!data?.roomId?.trim()) {
        errors.roomId = constantMessages.roomRequired;
      }
    } else {
      if (!data?.locationData?.trim()) {
        errors.locationData = constantMessages.locationRequired;
      } else if (!regularExpressionForAgendaTitle.test(data.locationData)) {
        errors.locationData = constantMessages.invalidInput;
      } else if (
        data.locationData.trim().length < 3 ||
        data.title.trim().length > 500
      ) {
        errors.locationData = constantMessages.largeStringLengthError;
      }
    }

    if (
      formData?.mode?.trim() === "virtual" &&
      formData?.linkType === "MANUAL"
    ) {
      if (!formData?.link?.trim()) {
        errors.link = constantMessages.linkRequired;
      }
    }

    // If Zoom is selected as link type, check required fields
    if (data.linkType === "ZOOM") {
      if (!data.date.trim()) {
        errors.linkType = "Please select a valid date for Zoom meeting.";
      }
      if (!data.fromTime.trim()) {
        errors.linkType = "Please select a valid from-time for Zoom meeting.";
      }
      if (!data.toTime.trim()) {
        errors.linkType = "Please select a valid to-time for Zoom meeting.";
      }
    }

    if (formData?.mode?.trim() === "virtual") {
      if (!formData?.linkType) {
        errors.linkType = "Please add link type";
      }
    }

    const regexp =
      /^(?:(?:https?:)?\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (formData.link.trim()) {
      if (!regexp.test(formData.link.trim())) {
        errors.link = constantMessages.invalidLink;
      }
    }
    return errors;
  };

  const fromDateFieldValidationCheckForPrevious = (e) => {
    setErrors({});
    const errors = {};
    if (!formData?.fromTime?.trim()) {
      errors.fromTime = constantMessages.timeRequired;
    } else if (previousMeetingData?.actualToTime) {
      const parentMeetingToTime = previousMeetingData?.actualToTime;
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const parentMeetingToTimeArray = parentMeetingToTime.split(":");
      const parentMeetingToHour = parentMeetingToTimeArray[0];
      const parentMeetingToMinute = parentMeetingToTimeArray[1];
      const mDate = dayjs(formData.date, "DD-MM-YYYY");
      if (
        mDate.format("YYYY-MM-DD") ===
        dayjs.utc(previousMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        if (fromTimeHour < parentMeetingToHour) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        } else if (
          fromTimeHour === parentMeetingToHour &&
          fromTimeMinute <= parentMeetingToMinute
        ) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        }
      }

      if (formData?.toTime?.trim()) {
        const fromTimeArray = formData.fromTime.split(":");
        const fromTimeHour = fromTimeArray[0];
        const fromTimeMinute = fromTimeArray[1];
        const toTimeArray = formData.toTime.split(":");
        const toTimeHour = toTimeArray[0];
        const toTimeMinute = toTimeArray[1];

        if (fromTimeHour > toTimeHour) {
          errors.fromTime = constantMessages.invalidFromHour;
        } else if (
          fromTimeHour === toTimeHour &&
          fromTimeMinute >= toTimeMinute
        ) {
          errors.fromTime = constantMessages.invalidFromMinute;
        }
      }
    } else if (formData?.toTime?.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.fromTime = constantMessages.invalidFromHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.fromTime = constantMessages.invalidFromMinute;
      }
    }

    setErrors(errors);
  };

  const fromDateFieldValidationCheck = (e) => {
    setErrors({});
    const errors = {};
    if (!formData?.fromTime?.trim()) {
      errors.fromTime = constantMessages.timeRequired;
    } else if (parentMeetingData?.actualToTime) {
      const parentMeetingToTime = parentMeetingData?.actualToTime;

      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const parentMeetingToTimeArray = parentMeetingToTime.split(":");
      const parentMeetingToHour = parentMeetingToTimeArray[0];
      const parentMeetingToMinute = parentMeetingToTimeArray[1];

      const mDate = dayjs(formData.date, "DD-MM-YYYY");

      if (
        mDate.format("YYYY-MM-DD") ===
        dayjs.utc(parentMeetingData?.actualDate).format("YYYY-MM-DD")
      ) {
        if (fromTimeHour < parentMeetingToHour) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        } else if (
          fromTimeHour === parentMeetingToHour &&
          fromTimeMinute <= parentMeetingToMinute
        ) {
          errors.fromTime =
            isPreviousChildMeetingAvailable === false
              ? constantMessages.invalidFromMinuteForParentMeeting
              : constantMessages.invalidFromMinuteForPreviousMeeting;
        }
      }

      if (formData.toTime.trim()) {
        const fromTimeArray = formData.fromTime.split(":");
        const fromTimeHour = fromTimeArray[0];
        const fromTimeMinute = fromTimeArray[1];
        const toTimeArray = formData.toTime.split(":");
        const toTimeHour = toTimeArray[0];
        const toTimeMinute = toTimeArray[1];

        if (fromTimeHour > toTimeHour) {
          errors.fromTime = constantMessages.invalidFromHour;
        } else if (
          fromTimeHour === toTimeHour &&
          fromTimeMinute >= toTimeMinute
        ) {
          errors.fromTime = constantMessages.invalidFromMinute;
        }
      }
    } else if (formData.toTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.fromTime = constantMessages.invalidFromHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.fromTime = constantMessages.invalidFromMinute;
      }
    }

    setErrors(errors);
  };
  const locationDetailsFieldValidationCheck = (e) => {
    const errors = {};

    if (formData.location === "meetingroom") {
      if (!unitId?.trim()) {
        errors.unitId = constantMessages.unitRequired;
      }
      if (!formData?.roomId?.trim()) {
        errors.roomId = constantMessages.roomRequired;
      }
    } else {
      if (!formData?.locationData?.trim()) {
        errors.locationData = constantMessages.locationRequired;
      } else if (!regularExpressionForAgendaTitle.test(formData.locationData)) {
        errors.locationData = constantMessages.invalidInput;
      } else if (
        formData.locationData.trim().length < 3 ||
        formData.title.trim().length > 500
      ) {
        errors.locationData = constantMessages.largeStringLengthError;
      }
    }
    setErrors(errors);
  };

  const toDateFieldValidationCheck = (e) => {
    setErrors({});

    const errors = {};
    if (!formData.toTime.trim()) {
      errors.toTime = constantMessages.timeRequired;
    } else if (formData.fromTime.trim()) {
      const fromTimeArray = formData.fromTime.split(":");
      const fromTimeHour = fromTimeArray[0];
      const fromTimeMinute = fromTimeArray[1];
      const toTimeArray = formData.toTime.split(":");
      const toTimeHour = toTimeArray[0];
      const toTimeMinute = toTimeArray[1];

      if (fromTimeHour > toTimeHour) {
        errors.toTime = constantMessages.invalidToHour;
      } else if (
        fromTimeHour === toTimeHour &&
        fromTimeMinute >= toTimeMinute
      ) {
        errors.toTime = constantMessages.invalidToMinute;
      }
    }
    setErrors(errors);
  };

  const titleFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.title.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.titleRegexError;
    } else if (
      formData.title.trim().length < 5 ||
      formData.title.trim().length > 100
    ) {
      errors.title = constantMessages.stringLengthError;
    }
    setErrors(errors);
  };

  const meetinRoomFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.roomId) {
      errors.roomId = constantMessages.roomRequired;
      setErrors(errors);
    }
    if (!unitId) {
      errors.unitId = constantMessages.unitRequired;
      setErrors(errors);
    }
  };

  const urlFieldValidationCheck = (e) => {
    const errors = {};
    const regexp =
      /^(?:(?:https?:)?\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (formData.link.trim()) {
      if (!regexp.test(formData.link.trim())) {
        errors.link = constantMessages.invalidLink;
        setErrors(errors);
      }
    }
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: 100,
      overflowY: "auto",
      zIndex: 9999, // Ensure it's on top of other elements
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 100,
      overflowY: "auto",
      zIndex: 9999, // Ensure it's on top of other elements
    }),
  };

  return (
    <div className="mt-2 details-form add-meetings">
      {meetingData.step === 3 && !meetingData.isNewMeetingPage ? (
        <Navigate
          to={`/view-meeting-details/${meetingData?.singleMeetingDetails?._id}`}
          state={{
            meetingId: meetingData?.singleMeetingDetails?._id,
            isViewMeetingPage: true,
          }}
        />
      ) : null}
      <CommonStepper
        fromEditMeeting={false}
        step={meetingData.isNewMeetingPage ? 0 : meetingData.step}
      />
      <br></br>

      {meetingData.step + 1 == 1 || meetingData.isNewMeetingPage === true ? (
        <form className="mt-0 p-0 details-form" onSubmit={submitMeetingDetails}>
          {parentMeetingData && !meetingData?.isClearState ? (
            <>
              <div className="form-group mb-2">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <label className="mb-1">Parent Meeting ID</label>
                  </div>
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                    <p>{parentMeetingData?.meetingId}</p>
                  </div>
                </div>
              </div>
              <div className="form-group mb-2">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <label className="mb-1">Parent Meeting Title</label>
                  </div>
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                    <p>{parentMeetingData?.title}</p>
                  </div>
                </div>
              </div>
              <div className="minutes-border"></div>
              {/* {parentMeetingData && !isPreviousChildMeetingAvailable ? (
                <div className="form-group">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">Parent Meeting Date & Time</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      <p>
                        {parentMeetingData?.date}, {parentMeetingData?.fromTime}{" "}
                        to {parentMeetingData?.toTime}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="form-group">
                  <div className="row">   
                     <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">               
                      <label className="mb-1">
                        Previous Meeting Date & Time
                      </label>
                      </div>
                      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                       <p>
                        {previousMeetingData?.date},{" "}
                        {previousMeetingData?.fromTime} to{" "}
                        {previousMeetingData?.toTime}{" "}
                      </p> 
                      </div>
                  </div>
                </div>
              )} */}
            </>
          ) : null}

          {previousMeetingData &&
          !parentMeetingData &&
          !meetingData?.isClearState ? (
            <>
              <div className="form-group mb-2">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <label className="mb-1">Previous Meeting ID</label>
                  </div>
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                    <p>{previousMeetingData?.meetingId}</p>
                  </div>
                </div>
              </div>
              <div className="form-group mb-2">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <label className="mb-1">Previous Meeting Title</label>
                  </div>
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                    <p>{previousMeetingData?.title}</p>
                  </div>
                </div>
              </div>
              {/* <div className="form-group">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <label className="mb-1">Previous Meeting Date & Time</label>
                  </div>
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                    <p>
                      {previousMeetingData?.date},{" "}
                      {previousMeetingData?.fromTime} to{" "}
                      {previousMeetingData?.toTime}{" "}
                    </p>
                  </div>
                </div>
              </div> */}
            </>
          ) : null}
          <div className="inner-detail-form">
            <div className="mb-3">
              <label className="mb-1" for="title">
                Title
              </label>
              <span className="star-mark">*</span>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter Meeting Title"
                onBlur={titleFieldValidationCheck}
                onKeyUp={titleFieldValidationCheck}
              />

              {errors.title && (
                <span className="error-message">{errors.title}</span>
              )}
            </div>

            <div className="mb-3">
              <div className="row">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="position-relative resp-input-margin-bottom">
                      <label className="mb-1 input-date">Date</label>
                      <span className="star-mark">*</span>
                      <DatePicker
                        name="date"
                        value={
                          formData.date
                            ? dayjs(formData.date, "DD-MM-YYYY")
                            : null
                        }
                        onChange={(newValue) => {
                          if (previousMeetingData) {
                            handledateChangeForPreviousMeeting(
                              "date",
                              newValue
                            );
                          } else {
                            handledateChange("date", newValue);
                          }
                        }}
                        className="svgg"
                        format="DD-MM-YYYY"
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            fullWidth: true,
                            size: "small",
                            placeholder: "dd-mm-yyyy",
                            inputProps: {
                              onDragStart: (e) => e.preventDefault(),
                              onDrop: (e) => e.preventDefault(),
                              onDragOver: (e) => e.preventDefault(),
                            },
                          },
                          day: (params) => ({
                            sx: {
                              backgroundColor: dayjs().isSame(params.day, "day")
                                ? ""
                                : "inherit",
                              color: dayjs().isSame(params.day, "day")
                                ? "blue"
                                : "inherit",
                              borderRadius: "0%",
                              "&:hover": {
                                backgroundColor: dayjs().isSame(
                                  params.day,
                                  "day"
                                ),
                              },
                            },
                          }),
                        }}
                      />
                    </div>
                    {errors.date && (
                      <span className="error-message">{errors.date}</span>
                    )}
                  </div>
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div className="position-relative resp-input-margin-bottom">
                      <label className="mb-1">From Time</label>
                      <span className="star-mark">*</span>
                      <TimePicker
                        name="fromTime"
                        value={
                          formData.fromTime
                            ? dayjs(`2000-01-01T${formData.fromTime}`)
                            : null
                        }
                        onChange={(newValue) => {
                          if (previousMeetingData) {
                            handledateChangeForPreviousMeeting(
                              "fromTime",
                              newValue
                            );
                          } else {
                            handledateChange("fromTime", newValue);
                          }
                        }}
                        onBlur={() => {
                          if (previousMeetingData) {
                            fromDateFieldValidationCheckForPrevious();
                          } else {
                            fromDateFieldValidationCheck();
                          }
                        }}
                        ampm={true}
                        timeSteps={{ minutes: 1 }}
                        format="HH:mm"
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            fullWidth: true,
                            size: "small",
                            placeholder: "hh:mm",
                            inputProps: {
                              onDragStart: (e) => e.preventDefault(),
                              onDrop: (e) => e.preventDefault(),
                              onDragOver: (e) => e.preventDefault(),
                            },
                          },
                        }}
                      />
                    </div>
                    {errors.fromTime && (
                      <span className="error-message">{errors.fromTime}</span>
                    )}
                  </div>
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div className="position-relative resp-input-margin-bottom">
                      <label className="mb-1">To Time</label>
                      <span className="star-mark">*</span>
                      <TimePicker
                        name="toTime"
                        value={
                          formData.toTime
                            ? dayjs(`2000-01-01T${formData.toTime}`)
                            : null
                        }
                        onChange={(newValue) => {
                          if (previousMeetingData) {
                            handledateChangeForPreviousMeeting(
                              "toTime",
                              newValue
                            );
                          } else {
                            handledateChange("toTime", newValue);
                          }
                        }}
                        ampm={true}
                        timeSteps={{ minutes: 1 }}
                        format="HH:mm"
                        slotProps={{
                          textField: {
                            variant: "outlined",
                            fullWidth: true,
                            size: "small",
                            placeholder: "hh:mm",
                            inputProps: {
                              onDragStart: (e) => e.preventDefault(),
                              onDrop: (e) => e.preventDefault(),
                              onDragOver: (e) => e.preventDefault(),
                            },
                          },
                        }}
                      />
                    </div>
                    {errors.toTime && (
                      <span className="error-message">{errors.toTime}</span>
                    )}
                  </div>
                </LocalizationProvider>

                {parentMeetingData && !isPreviousChildMeetingAvailable ? (
                  // <div className="form-group">
                  //   <div className="row">
                  //     <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  //       <label className="mb-1">
                  //         Parent Meeting Date & Time2
                  //       </label>
                  //     </div>
                  //     <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  //       <p>
                  //         {parentMeetingData?.date},{" "}
                  //         {parentMeetingData?.fromTime} to{" "}
                  //         {parentMeetingData?.toTime}{" "}
                  //       </p>
                  //     </div>
                  //   </div>
                  // </div>

                  <div className="d-flex align-items-center text-secondary fs-12 mt-2 font-italic">
                    <span> Parent Meeting Date & Time: &nbsp;</span>
                    <p className="text-secondary fs-12">
                      {parentMeetingData?.date}, {parentMeetingData?.fromTime}{" "}
                      to {parentMeetingData?.toTime}{" "}
                    </p>
                  </div>
                ) : previousMeetingData ? (
                  <div className="d-flex align-items-center text-secondary fs-12 mt-2 font-italic">
                    <span>Previous Meeting Date & Time: &nbsp;</span>
                    <p className="text-secondary fs-12">
                      {" "}
                      {previousMeetingData?.date},{" "}
                      {previousMeetingData?.fromTime} to{" "}
                      {previousMeetingData?.toTime}
                    </p>
                  </div>
                ) : null}
              </div>
              {errors.zoomError && (
                <span className="error-message">{errors.zoomError}</span>
              )}
            </div>

            <div className="mb-3">
              <label className="mb-1">Meeting Mode</label>
              <span className="star-mark">*</span>

              <div className="w-100 resp-grid">
                <div className="form-check form-check-inline">
                  <input
                    id="virtualMeeting"
                    className="form-check-input"
                    type="radio"
                    name="mode"
                    value="virtual"
                    onChange={handleChange}
                    checked={formData.mode === "virtual"}
                  />
                  <label htmlFor="virtualMeeting" className="form-check-label">
                    Virtual Meeting
                  </label>
                </div>

                <div className="form-check form-check-inline padding-left-0">
                  <div className="form-check">
                    <input
                      id="physicalMeeting"
                      className="form-check-input"
                      type="radio"
                      name="mode"
                      value="physical"
                      onChange={handleChange}
                      checked={formData.mode === "physical"}
                    />
                    <label
                      htmlFor="physicalMeeting"
                      className="form-check-label"
                    >
                      Physical Meeting
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {formData.mode === "virtual" ? (
              <div className="mb-3">
                <label className="mb-1">Select Link Type</label>
                <span className="star-mark">*</span>
                <select
                  // aria-placeholder="Select Link Type"
                  name="linkType"
                  value={formData.linkType || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (previousMeetingData) {
                      if (value === "ZOOM") {
                        handledateChangeForPreviousMeeting("linkType", value);
                      } else {
                        setFormData((prev) => ({ ...prev, linkType: value }));
                      }
                    } else {
                      if (value === "ZOOM") {
                        handledateChange("linkType", value);
                      } else {
                        setFormData((prev) => ({ ...prev, linkType: value }));
                      }
                    }
                  }}
                >
                  {/* <option value="">Select Link Type</option>{" "} */}
                  <option value="MANUAL">My Link</option>
                  {zoomCred?.isActive === true &&
                  zoomCred?.clientId &&
                  zoomCred?.clientId !== "" &&
                  zoomCred?.accountId &&
                  zoomCred?.accountId !== "" &&
                  zoomCred?.secretToken &&
                  zoomCred?.secretToken !== "" ? (
                    <option value="ZOOM">Zoom</option>
                  ) : null}
                  {gmeetCred?.isActive === true &&
                  gmeetCred?.tokenData &&
                  gmeetCred?.tokenData?.refreshToken !== "" &&
                  gmeetCred?.tokenData?.clientId !== "" &&
                  gmeetCred?.tokenData?.secretToken !== "" ? (
                    <option value="GMEET"> Google Meet</option>
                  ) : null}
                  {msTeamsCred?.isActive === true &&
                  msTeamsCred?.tokenData &&
                  msTeamsCred?.tokenData?.accessToken !== "" &&
                  msTeamsCred?.tokenData?.refreshToken !== "" ? (
                    <option value="MSTEAMS">Microsoft Teams</option>
                  ) : null}
                </select>
                {errors.linkType && (
                  <span className="error-message">{errors.linkType}</span>
                )}
              </div>
            ) : null}
            {formData.linkType === "MANUAL" || formData.mode === "physical" ? (
              <div className="mb-3">
                <label className="mb-1">Meeting Link</label>
                {formData.linkType === "MANUAL" &&
                formData.mode === "virtual" ? (
                  <span className="star-mark">*</span>
                ) : null}
                <input
                  type="text"
                  placeholder="Enter Meeting Link"
                  name="link"
                  value={formData.link}
                  onChange={handleChange}
                  onBlur={urlFieldValidationCheck}
                  autoComplete="off"
                />
                {errors.link && (
                  <span className="error-message">{errors.link}</span>
                )}
              </div>
            ) : null}
            <div className="mb-3">
              <label className="mb-1" for="location">
                Location
              </label>
              <span className="star-mark">*</span>
              <div className="w-100 resp-grid  mb-2">
                <div className="form-check form-check-inline">
                  {}
                  <input
                    id="locationtype1"
                    className="form-check-input"
                    type="radio"
                    name="location"
                    value="manual"
                    onChange={handleChange}
                    checked={formData.location === "manual"}
                  />
                  <label
                    className="form-check-label"
                    for="locationtype1"
                    id="locationtype1"
                  >
                    Enter Manually
                  </label>
                </div>
                <div className="form-check form-check-inline padding-left-0">
                  <div className="form-check">
                    <input
                      id="locationtype2"
                      className="form-check-input"
                      type="radio"
                      name="location"
                      value="meetingroom"
                      onChange={handleChange}
                      checked={formData.location === "meetingroom"}
                    />
                    <label
                      className="form-check-label"
                      for="locationtype2"
                      id="locationtype2"
                    >
                      Select A Meeting Room
                    </label>
                  </div>
                </div>
              </div>
              {formData.location === "meetingroom" ? (
                <div className="mb-3">
                  <label className="mb-1">Select Unit</label>
                  <span className="star-mark">*</span>
                  <Select
                    className="fltr-opt  z-index-high"
                    defaultValue={selectedUnitOption}
                    value={selectedUnitOption}
                    name="unitId"
                    options={unitOptions}
                    onChange={handleUnitChange}
                    styles={customStyles}
                  />
                  {errors.unitId && (
                    <span className="error-message">{errors.unitId}</span>
                  )}
                </div>
              ) : null}

              {formData.location !== "meetingroom" ? (
                <>
                  <textarea
                    className="mt-1"
                    placeholder="Enter Location"
                    id=""
                    cols="56"
                    rows="3"
                    onChange={handleChange}
                    name="locationData"
                    value={formData.locationData}
                    onBlur={locationDetailsFieldValidationCheck}
                  ></textarea>
                  <p className="success-message">
                    {checkCharacterLeft(formData.locationData)} Characters left
                  </p>
                  {errors.locationData && (
                    <span className="error-message">{errors.locationData}</span>
                  )}
                </>
              ) : (
                <>
                  {unitId ? (
                    <div className="mb-3">
                      <label className="mb-1">Select Room</label>
                      <span className="star-mark">*</span>
                      <Select
                        className="fltr-opt"
                        defaultValue={selectedRoomOption}
                        value={selectedRoomOption}
                        name="roomId"
                        options={roomOptions}
                        onChange={handleRoomChange}
                        onBlur={meetinRoomFieldValidationCheck}
                        styles={customStyles}
                      />
                      {errors.roomId && (
                        <span className="error-message">{errors.roomId}</span>
                      )}
                    </div>
                  ) : null}
                </>
              )}
            </div>

            {!roomErrors.room && errors.room && (
              <div className="error-message">{errors.room}</div>
            )}
            {!errors.room && roomErrors.room && (
              <div className="error-message">{roomErrors.room}</div>
            )}
            <div className="button-outer">
              {!meetingData.updateLoading && !meetingData.isUpdateStep ? (
                <>
                  <button
                    className="create-meeting-button Mom-btn"
                    type="submit"
                  >
                    <p>Save & Proceed</p>
                  </button>
                </>
              ) : !meetingData.updateLoading && meetingData.isUpdateStep ? (
                <button className="create-meeting-button Mom-btn" type="submit">
                  <p>Update</p>
                </button>
              ) : (
                <SmallLoaderButton />
              )}
              {!meetingData.updateLoading && meetingData.isUpdateStep ? (
                <button
                  className="create-meeting-button Mom-btn"
                  onClick={(e) => {
                    dispatch(updateStep(1, true));
                    dispatch(setErrorMessage(null));
                    setRoomErrors({});
                    setErrors({});
                  }}
                >
                  <p>Next</p>
                </button>
              ) : null}
            </div>
          </div>
          {meetingData?.errorMessage && (
            <div className="attendee-array-error-messages mt-3">
              <ul className="error-list error-message">
                {(Array.isArray(meetingData.errorMessage)
                  ? meetingData.errorMessage
                  : [meetingData.errorMessage]
                ).map((error, index) => (
                  <li key={index} className="error-item">
                    {error}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </form>
      ) : meetingData.step + 1 === 2 && !meetingData.isNewMeetingPage ? (
        <>
          <AddAttendees />
        </>
      ) : meetingData.step + 1 === 3 && !meetingData.isNewMeetingPage ? (
        <>
          <AddAgendas showRemoveButton={true} />
        </>
      ) : null}
    </div>
  );
};

export default AddMeeting;
